import {Injectable} from '@angular/core';
import {User} from '../api/models/user';
import {UserState} from '../modules/akita-mimic/models/store-states/user-state.model';
import {EntityStoreService} from '../modules/akita-mimic/services/entity-store.service';

@Injectable({ providedIn: 'root' })
export class UserStore extends EntityStoreService<UserState, User> {
    public constructor() {
        super('user', {
            ids: [],
            entities: {},
            active: [],
            loading: false,
            selected: undefined,
        });
    }
}
